import Grid from "@mui/material/Grid";

import i18n from "../../../../../constants/i18n";
import {
  HAVING_KIDS,
  MARITAL_STATUS_FEMALE,
  MARITAL_STATUS_MALE,
  TYPE_OF_MARRIAGE
} from "../../../../../constants/picker-entries-constants";
import { KHATTABAT_MATCHING_FIELD_SIZE } from "../../../../../constants/user-profile";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import { Gender } from "../../../../../Types";
import FilterMultiSelect from "./FilterMultiSelect";
import FilterSelect from "./FilterSelect";
import React from "react";

const KhattabatMatchingFamilyFilters = withLiteObserverAndTheme(() => {
  const maleCurrentClient =
    getKhattabatMatchingStore().currentClientInformation.get().gender ===
    Gender.Male;

  return (
    <React.Fragment>
      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("TYPE_OF_MARRIAGE")}
          options={TYPE_OF_MARRIAGE}
          value={getKhattabatMatchingStore().matchMarriageType.get()}
          onChange={getKhattabatMatchingStore().setMarriageState}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterMultiSelect
          label={i18n.get("MARITAL_STATUS")}
          options={
            maleCurrentClient ? MARITAL_STATUS_FEMALE : MARITAL_STATUS_MALE
          }
          value={getKhattabatMatchingStore().matchMaritalStatus.get()}
          onChange={getKhattabatMatchingStore().setMatchMaritalStatus}
        />
      </Grid>

      <Grid size={KHATTABAT_MATCHING_FIELD_SIZE}>
        <FilterSelect
          label={i18n.get("HAVING_KIDS")}
          options={HAVING_KIDS}
          value={getKhattabatMatchingStore().matchHavingKids.get()}
          onChange={getKhattabatMatchingStore().setMatchHavingKids}
        />
      </Grid>
    </React.Fragment>
  );
});

export default KhattabatMatchingFamilyFilters;
